import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { providerForSelector, ProviderSearchViewModel } from "src/erp/arap/rawData/providerSelector-viewModel";
import { measuredProductDto, product, ProductSelector } from "src/erp/inventory/rawData/product/productSelector";
import { WarehouseSelector } from "src/erp/inventory/rawData/warehouse/warehouseSelector";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { FileSelectorViewModel } from "uicomponents";
import  { CreateInvoiceView } from "./createInvoice-view"

export class CreateInvoiceViewModel extends WindowViewModel implements IPopup{
    public getTitle(): string{
        return "ثبت فاکتور خرید";
    }

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.isEvaluating = false;
        this.lineItems = ObservableArray.create<LineItem>();
        this.warehouseSelector = new WarehouseSelector(this);
        this.projectSelector = new ProjectSelector(this);
        this.warehouseSelector.onSelectionChanged = x=>{
            if(x==null)
                this.selectedWarehouseName = '';
            else
                this.selectedWarehouseName = x.title;
            this.lineItemsChanged();
        }
        this.fileSelector = new FileSelectorViewModel(this);
        this.productSearch = new ProductSelector(this);
        this.productSearch.onSelectionChanged = product=>this.onNewProductSelected(product);
        this.providerSearcher = new ProviderSearchViewModel(this);
        this.providerSearcher.onSelectionChanged = customer =>this.customerSelected(customer);

    }

    GetDefaultView(): View <ViewModel> {
        return new CreateInvoiceView();
    }
    public getTypeId(): string {
        return "VM-AF71D4F6-B138-496A-B358-A5C7EF8272DB"
    }
    
    public set factorId(v: string) { this._factorId = v; } public get factorId(): string { return this._factorId;} private _factorId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems;} private _lineItems: ObservableArray<LineItem>;
    public set productSearch(v: ProductSelector) { this._productSearch = v; } public get productSearch(): ProductSelector { return this._productSearch;} private _productSearch: ProductSelector;
    public set totalPrice(v: number) { this._totalPrice = getAsNumber(v,true);; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set elementCount(v: number) { this._elementCount = getAsNumber(v,true);; } public get elementCount(): number { return this._elementCount;} private _elementCount: number;
    public set additions(v: number) { this._additions = getAsNumber(v,true);; } public get additions(): number { return this._additions;} private _additions: number;
    public set deficits(v: number) { this._deficits = getAsNumber(v,true);; } public get deficits(): number { return this._deficits;} private _deficits: number;
    public set finalPrice(v: number) { this._finalPrice = getAsNumber(v,true);; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set transportPrice(v: number) { this._transportPrice = getAsNumber(v,true);; } public get transportPrice(): number { return this._transportPrice;} private _transportPrice: number;
    public set transportAddress(v: string) { this._transportAddress = v; } public get transportAddress(): string { return this._transportAddress;} private _transportAddress: string;
    public set providerSearcher(v: ProviderSearchViewModel) { this._providerSearcher = v; } public get providerSearcher(): ProviderSearchViewModel { return this._providerSearcher;} private _providerSearcher: ProviderSearchViewModel;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set projectSelector(v: ProjectSelector) { this._projectSelector = v; } public get projectSelector(): ProjectSelector { return this._projectSelector;} private _projectSelector: ProjectSelector;
    public set selectedWarehouseName(v: string) { this._selectedWarehouseName = v; } public get selectedWarehouseName(): string { return this._selectedWarehouseName;} private _selectedWarehouseName: string;
    public set tempFactorNo(v: string) { this._tempFactorNo = v; } public get tempFactorNo(): string { return this._tempFactorNo;} private _tempFactorNo: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;

    closePopup() {}
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/MakeImportTemplateFile',{
            });
            downloadFile(result.ExcelFile, `lineItem Template.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/ImportLineItems',{
                ExcelFile : this.fileSelector.filecontent
            });
            let popup = new Verification(this);
            popup.lineItems.update(...result.LineItems.map(q=>{
                let l = new LineItem(this);
                l.measuredProductId = q.MeasuredProductId;
                l.productCode = q.ProductCode;
                l.productName = q.ProductName;
                l.unitName = q.UnitName;
                l.amount = q.Amount;
                l.fee = q.ProvidedFee;
                l.additions = q.Additions;
                l.deficit = q.Deficits;
                l.hasBalanceError = !q.IsFound;
                return l;
            }));
            this.showPopup(popup);
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async acceptImport(importedLineItems: ObservableArray<LineItem>){
        try {
            this.isLoading = true;
            importedLineItems.map(q=>{
                if (!q.hasBalanceError) {   
                    let p = new product(this);
                    p.id = q.productId;
                    p.code = q.productCode;
                    p.name = q.productName;
                    let m = new measuredProductDto(this);
                    m.id = q.measuredProductId;
                    m.unitId = q.unitId;
                    m.unitName = q.unitName;
                    this.onNewMeasuredProductSelected(p, m, q.amount, q.fee, q.additions, q.deficit);
                }
            })
            this.lineItemsChanged();
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    onNewProductSelected(product: product): void {
        if(product.measuredProducts.length==1){
            this.onNewMeasuredProductSelected(product,product.measuredProducts[0]);
        }
    }
    onNewMeasuredProductSelected(product: product, measurable: measuredProductDto, amount = 1, fee = 0, addition = 0, deficit = 0) {
        let lineItem = new LineItem(this);
        lineItem.measuredProductId = measurable.id;
        lineItem.productCode = product.code;
        lineItem.productId = product.id;
        lineItem.productName = product.name;
        lineItem.unitId = measurable.unitId;
        lineItem.unitName = measurable.unitName;
        lineItem.amount = amount;
        lineItem.fee = fee;
        lineItem.deficit = deficit;
        lineItem.additions = addition;
        this.addLineItem(lineItem);
    }
    addLineItem(lineItem:LineItem){
        this.lineItems.push(lineItem);
        this.lineItemsChanged();

    }

    removeLineItem(lineItem: LineItem){
        this.lineItems.remove(lineItem);
        this.lineItemsChanged();
    }

    private lineItemsChangedTimer:any;
    private isEvaluating:boolean;
    lineItemsChanged(){
        if(this.lineItemsChangedTimer!=null)
            clearTimeout(this.lineItemsChangedTimer);
        this.lineItemsChangedTimer = setTimeout(async ()=>{
            if(this.isEvaluating==false){
                this.isEvaluating = true;
                await this.calcualteFactor()
                this.isEvaluating = false;
            }
        },500);
    }

    private async calcualteFactor(){
        try {
            if (this.lineItems.length == 0){
                this.totalPrice = 0;
                this.additions = 0;
                this.deficits = 0;
                this.finalPrice = 0;
                this.transportPrice = 0;
                this.elementCount = 0;
            }else{
                this.isLoading = true;
                this.lineItems.forEach(x=>{
                    x.totalPrice = x.fee * x.amount;
                    x.finalPrice = x.totalPrice + x.additions - x.deficit;
                })

                this.totalPrice = this.lineItems.reduce((a,c)=>a+c.totalPrice,0);
                this.finalPrice = this.lineItems.reduce((a,c)=>a+c.finalPrice,0);
                this.deficits = this.lineItems.reduce((a,c)=>a+c.deficit,0);
                this.additions = this.lineItems.reduce((a,c)=>a+c.additions,0);
                this.elementCount = this.lineItems.reduce((a,c)=>a+c.amount,0);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
     
    customerSelected(customer: providerForSelector): void {
        this.customerName = customer.name;
        this.customerCode = customer.code;
    }

    requestCreatePurchaseFactor() {
        let validationResult = this.validate();
        if(stringIsNullOrEmpty(validationResult)){
            let popup = new purchaseFactorReport(this);
            popup.createPurchaseFactorViewModel = this;
            this.showPopup(popup);
        }else{
            this.messageBoxConfirmWarning(validationResult,'اطلاعات ناکافی');
        }
    }

    private validate():string{
        let errors = [];
        if(this.lineItems.length==0){
            errors.push('هیچ ردیفی ثبت نشده است.');
        }
        if(this.lineItems.filter(x=>x.fee<=0 || x.amount<=0 || x.additions<0 || x.deficit<0).length>0){
            errors.push('قیمت و یا میزان منفی برای کالا امکان پذیر نیست');
        }
        if(this.providerSearcher.selectedItem==null){
            errors.push('مشتری مشخص نشده است');
        }
        if(this.warehouseSelector.selectedItem==null){
            errors.push('انبار دریافت مشخص نشده است.')
        }
        let result = errors.join('\r\n');
        return result;
    }

    async createFactor(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/CreateNewPurchaseInvoice',{
                ProviderId:this.providerSearcher.selectedItem.id,
                WarehouseId:this.warehouseSelector.selectedItem.id,
                ProjectId:this.projectSelector.selectedItem?.id,
                LineItems : this.lineItems.map(x=>{
                    return {
                        MeasuredProductId:x.measuredProductId,
                        Amount:x.amount,
                        ProvidedFee:x.fee,
                        Deficits:x.deficit,
                        Additions:x.additions
                    };
                })
            });
            if(result.IsSuccessful){
                this.tempFactorNo = result.FactorNo;
                this.factorId = result.Id;
                await this.messageBoxConfirmSuccess(`فاکتور با شماره ${this.tempFactorNo} صادر شد.`,
                    'ثبت فاکتور');
                this.close();
            } else{
                throw "عدم امکان ثبت فاکتور";
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا در عملیات');
        } finally {
            this.isLoading = false;
        }
    }

    async createPayment(){
        try {
            let result = await ServerConnection.callServer('/Complex/PurchaseServices/AddCashPaymentForPurchaseInvoice',{
                InvoiceId:this.factorId,
                Amount:this.finalPrice,
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess(`پرداخت به شکل نقدی تکمیل شد.`,'پرداخت موفق');
            } else{
                throw "عدم امکان پرداخت";
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا در عملیات');
        } finally {
        }
    }
}

export class Verification extends ViewModel implements IPopup{
    public getTypeId(): string {return 'verification';}
    public GetDefaultView(): View<ViewModel> {return null;}
    closePopup() {}
    constructor(parent:CreateInvoiceViewModel) {
        super(parent);
        this._parent = parent;
        this.lineItems = ObservableArray.create<LineItem>();

    }

    public set lineItems(v: ObservableArray<LineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<LineItem> { return this._lineItems;} private _lineItems: ObservableArray<LineItem>;

    private _parent : CreateInvoiceViewModel;

    async accept(){
        this._parent.acceptImport(this.lineItems);
        this.closePopup();
    }
}

export class LineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CreateInvoiceViewModel) {
        super(parent);
        this.typedParent = parent;
        this.fee =0;
        this.additions =0;
        this.deficit =0;
        this.amount = 0;
    }
    
    private typedParent: CreateInvoiceViewModel;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId;} private _measuredProductId: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set unitId(v: string) { this._unitId = v; } public get unitId(): string { return this._unitId;} private _unitId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName;} private _unitName: string;
    public set amount(v: number) { 
        if(this.amount!= getAsNumber(v,true)){
            this._amount = getAsNumber(v,true);
            this.checkBalanceError();
            this.typedParent.lineItemsChanged();
        }
    } public get amount(): number { return this._amount;} private _amount: number;
    public set fee(v: number) { 
        if(this.fee!= getAsNumber(v,true)){
            this._fee = getAsNumber(v,true);
            this.typedParent.lineItemsChanged();
        }
    } public get fee(): number { return this._fee;} private _fee: number;
    public set totalPrice(v: number) { this._totalPrice = getAsNumber(v,true);; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set additions(v: number) { 
        if(this.additions != getAsNumber(v,true)){
            this._additions = getAsNumber(v,true);
            this.typedParent.lineItemsChanged();
        }
    } public get additions(): number { return this._additions;} private _additions: number;
    public set deficit(v: number) { 
        if(this.deficit!= getAsNumber(v,true)){    
            this._deficit = getAsNumber(v,true); 
            this.typedParent.lineItemsChanged();
        }
    } public get deficit(): number { return this._deficit;} private _deficit: number;
    public set finalPrice(v: number) { this._finalPrice = getAsNumber(v,true); } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set hasBalanceError(v: boolean) { this._hasBalanceError = v; } public get hasBalanceError(): boolean { return this._hasBalanceError;} private _hasBalanceError: boolean;

    private checkBalanceError(){
        if(this.amount<=0){
            this.hasBalanceError = true;
        }else{
            this.hasBalanceError = false;
        }
    }

    remove(){
        this.typedParent.removeLineItem(this);
    }
}

export class purchaseFactorReport extends ViewModel implements IPopup{
    public getTypeId(): string {return 'self-report';}
    public GetDefaultView(): View<ViewModel> {return null;}
    closePopup() {}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set createPurchaseFactorViewModel(v: CreateInvoiceViewModel) {
        this._createFactorViewModel = v; 
        v.closePopup = ()=>this.closePopup();
    } public get createPurchaseFactorViewModel(): CreateInvoiceViewModel { return this._createFactorViewModel;} private _createFactorViewModel: CreateInvoiceViewModel;
    
}

export class Confirmation extends ViewModel implements IPopup{
    public getTypeId(): string {return 'confirmation';}
    public GetDefaultView(): View<CreateInvoiceViewModel> {return null;}
    constructor(parent:CreateInvoiceViewModel) {
        super(parent);
        this.allInfo = parent;
    }
    
    closePopup() {

    }

    public set allInfo(v: CreateInvoiceViewModel) { this._allInfo = v; } public get allInfo(): CreateInvoiceViewModel { return this._allInfo;} private _allInfo: CreateInvoiceViewModel;
    
}

export class ProjectSelector extends SelectorBaseViewModel<Project>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    protected async loadData(): Promise<Project[]> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/BpmsServices/GetFlowInstances", {
                FurtherQueryInfo: { "PaginationInfo": { "PageNo": 1, "PageSize": 3000 }, "OrderInfo": [], "Filters": { "FilterString": "" } },
                ProcessId: '6146740B-F81C-4EAE-9567-0E356D0E42C1',
                AllData:false,
                SelectedColumns:[
                    {FieldName:'ProjectName',FieldPath:'ProjectName'}
                ]
            });
            return result.Rows.map(x=>{
                let r = new Project(this);
                r.id=x.InstanceId;
                r.title = x.ProjectName;
                return r;
            })
        } catch (ex) {
            console.log(ex);
            return Promise.resolve<Project[]>([]);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class Project extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}